// Helper component with icon
const DisplayField = ({ label, value, icon }: any) => (
   <div className="flex items-start">
     <span className="text-xl mr-3 mt-0.5">{icon}</span>
     <div>
       <p className="text-sm text-gray-500 font-medium">{label}</p>
       <p className="text-lg text-gray-800 font-semibold mt-0.5">
         {value || "N/A"}
       </p>
     </div>
   </div>
 );

 export default DisplayField;